import { AxiosResponse } from 'axios';
import { request } from '../index';

const serviceGetToken = (
	login: string,
	password: string,
): Promise<AxiosResponse<{ accessToken: string; refreshToken: string }>> => {
	const authorizationData = {
		email: login,
		userPassword: password,
		clientId: 'SecretClient',
		clientSecret: 'Secret',
	};
	return request({ typeOfRequest: 'postWithoutToken', url: `/api/Auth`, data: authorizationData });
};

// const serviceUpdateRefreshToken = (refreshToken: string): Promise<TODO_ANY> => {
// 	const dataForSend = {
// 		clientId: 'SecretClient',
// 		clientSecret: 'Secret',
// 		refreshToken: refreshToken,
// 	};
// 	return request('postWithoutToken', `/api/Auth/RefreshToken`, dataForSend);
// };

// const serviceValidateAccessToken = (): Promise<TODO_ANY> => {
// 	const dataForSend = {
// 		accessToken: localStorage.getItem('accessToken'),
// 	};
// 	return request('postWithoutToken', `/api/Auth/ValidateAccessToken`, dataForSend);
// };

const serviceSendEmail = (email: string): Promise<AxiosResponse<void>> => {
	return request({
		typeOfRequest: 'postWithoutToken',
		url: `/api/UserPassword/sendResetToken?email=${email}`,
		data: {},
	});
};

const serviceSendNewPassword = (
	password: string,
	urlParams: { passwordResetToken: string; email: string },
): Promise<AxiosResponse<void>> => {
	const dataForSend = {
		email: urlParams.email,
		passwordResetToken: urlParams.passwordResetToken,
		newPassword: password,
	};
	return request({ typeOfRequest: 'putWithoutToken', url: `/api/UserPassword`, data: dataForSend });
};

export { serviceGetToken, serviceSendEmail, serviceSendNewPassword };
